// @/mixins/dateFormatMixin.js
import moment from "moment";

export default {
  computed: {
    dateFormatPlaceholder() {
      return this.$i18n.locale === "en" ? "YYYY-MM-DD" : "DD/MM/YY";
    },
  },
  methods: {
    formatDateForDisplay(date) {
      if (!date) return "";

      if (typeof date === "string") {
        // Pour l'anglais
        if (this.$i18n.locale === "en") {
          return moment(date).format("YYYY-MM-DD");
        }
        // Pour le français
        return moment(date).format("DD/MM/YY");
      }
      return "";
    },

    formatDateTimeForDisplay(date) {
      if (!date) return "";

      if (typeof date === "string") {
        // Pour l'anglais
        if (this.$i18n.locale === "en") {
          return moment(date).format("YYYY-MM-DD HH:mm");
        }
        // Pour le français
        return moment(date).format("DD/MM/YY [à] HH:mm");
      }
      return "";
    },
    formatRelativeTime(date) {
      if (!date) return "";

      const now = moment();
      const dateTime = moment(date);
      const diff = now.diff(dateTime, "minutes");

      // Moins d'une heure
      if (diff < 60) {
        return this.$i18n.locale === "en"
          ? `${diff} minute${diff !== 1 ? "s" : ""} ago`
          : `il y a ${diff} minute${diff > 1 ? "s" : ""}`;
      }

      // Moins d'un jour
      if (diff < 24 * 60) {
        const hours = Math.floor(diff / 60);
        return this.$i18n.locale === "en"
          ? `${hours} hour${hours !== 1 ? "s" : ""} ago`
          : `il y a ${hours} heure${hours > 1 ? "s" : ""}`;
      }

      // Moins d'une semaine
      if (diff < 7 * 24 * 60) {
        const days = Math.floor(diff / (24 * 60));
        return this.$i18n.locale === "en"
          ? `${days} day${days !== 1 ? "s" : ""} ago`
          : `il y a ${days} jour${days > 1 ? "s" : ""}`;
      }

      // Sinon, afficher la date complète
      return this.formatDateForDisplay(date);
    },

    formatDateRange(date1, date2) {
      if (date1 && date2) {
        return `${this.formatDateForDisplay(
          date1
        )} →  ${this.formatDateForDisplay(date2)}`;
      } else if (date1) {
        return this.formatDateForDisplay(date1);
      } else if (date2) {
        return this.formatDateForDisplay(date2);
      }
      return "";
    },

    parseDateFromDisplay(displayDate) {
      if (!displayDate) return null;
      const format = this.$i18n.locale === "en" ? "YYYY-MM-DD" : "DD/MM/YY";
      return moment(displayDate, format).format("YYYY-MM-DD");
    },

    // Méthode robuste pour formater les dates avec gestion d'erreurs et multiples formats
    formatDateRobust(date) {
      if (!date) return '-';
      
      try {
        let momentDate;
        
        if (typeof date === 'string') {
          // Liste des formats possibles à essayer dans l'ordre de priorité
          const formats = [
            'YYYY-MM-DD',           // Format ISO standard
            'YYYY-MM-DD HH:mm:ss',  // Format ISO avec heure
            'DD/MM/YYYY',           // Format français
            'DD/MM/YY',             // Format français court
            'MM/DD/YYYY',           // Format américain
            'MM/DD/YY',             // Format américain court
            'YYYY/MM/DD',           // Format alternatif
          ];
          
          // Essayer chaque format jusqu'à en trouver un qui fonctionne
          for (const format of formats) {
            momentDate = moment(date, format, true); // strict parsing
            if (momentDate.isValid()) {
              break;
            }
          }
          
          // Si aucun format strict ne fonctionne, essayer le parsing automatique en dernier recours
          if (!momentDate || !momentDate.isValid()) {
            momentDate = moment(date);
          }
        } else if (typeof date === 'number') {
          // Si c'est un timestamp
          momentDate = moment(date);
        } else {
          // Si c'est déjà un objet Date
          momentDate = moment(date);
        }
        
        if (momentDate && momentDate.isValid()) {
          return this.formatDateForDisplay(momentDate.format('YYYY-MM-DD'));
        } else {
          console.warn('⚠️ Date invalide après tous les essais:', date);
          return String(date); // Retourner la valeur originale convertie en string
        }
      } catch (error) {
        console.error('❌ Erreur lors du formatage de la date:', error, date);
        return String(date); // Retourner la valeur originale convertie en string
      }
    },
  },
};
